const GROUP_ROLES = ['owner', 'admin', 'moderator', 'member'];
const MOD_ROLES = ['owner', 'admin', 'moderator'];
const ADMIN_ROLES = ['owner', 'admin'];

function isAllowedByPolicy(policy, membership) {
  const role = membership?.role;
  if (!role || membership?.status !== 'active') {
    return false;
  }
  const effective = policy || 'members_allowed';
  if (effective === 'members_allowed') {
    return GROUP_ROLES.includes(role);
  }
  if (effective === 'mods_and_admins') {
    return MOD_ROLES.includes(role);
  }
  if (effective === 'admins_only') {
    return ADMIN_ROLES.includes(role);
  }
  return false;
}

/**
 * Mirror backend isAllowedByInvitePolicy in groups.js
 */
export function canInviteMembers(group, membership) {
  return isAllowedByPolicy(group?.invite_policy, membership);
}

/**
 * Mirror backend event_create_policy checks
 */
export function canCreateGroupEvents(group, membership) {
  return isAllowedByPolicy(group?.event_create_policy, membership);
}

export function canAddGroupRssFeeds(group, membership) {
  return isAllowedByPolicy(group?.rss_add_policy, membership);
}

export { GROUP_ROLES, MOD_ROLES, ADMIN_ROLES };
